import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../../shared.module';
import { AuthService } from 'src/app/core/services/auth.service';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { SupportCardComponent } from './support-card/support-card.component';
import { ToolsCardComponent } from './tools-card/tools-card.component';
import { WelcomeCardComponent } from './welcome-card/welcome-card.component';
import { LucideAngularModule } from 'lucide-angular';

@Component({
	selector: 'app-home',
	standalone: true,
	imports: [
		SharedModule,
		LucideAngularModule,
		MatCardModule,
		MatIconModule,
		MatChipsModule,
		SupportCardComponent,
		ToolsCardComponent,
		WelcomeCardComponent
	],
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
	currentUserInfo: any;
	userCompany: string = '';

	constructor(private readonly authService: AuthService) {}

	ngOnInit(): void {
		this.getUserInfo();
		this.getUserCompany();
	}

	private getUserInfo() {
		this.currentUserInfo = this.authService.getUserName();
	}

	private getUserCompany() {
		this.authService.userCompany.subscribe(companyInfo => {
			this.userCompany = companyInfo.razonSocial || '';
		});
	}
}
